import type { ReactNode } from 'react';
import clsx from 'clsx';
import { SHOW_DRAFT_MARKERS } from '@/config';

// Flags copy the client has not approved. Renders nothing in production.
export function DraftMarker({ children, className }: { children: ReactNode; className?: string }) {
  if (!SHOW_DRAFT_MARKERS) return null;
  return (
    <p
      className={clsx(
        'inline-block border border-dashed border-draft-border bg-draft-bg px-2 py-[3px] font-mono text-[0.75rem] text-draft-text',
        className,
      )}
    >
      {children}
    </p>
  );
}
